import styled from "@emotion/styled";
export const StyledSlimFooterComponent = styled.div`
  margin: auto;
`;
